import type { GlobalFeatureFlagsMap } from './domain/globalFeatureFlags';
import {
  fetchGlobalFeatureFlags,
  getCachedGlobalFeatureFlagsForSync,
} from './globalFeatureFlagsService';

export const DEVICE_COMMAND_INBOX_KEY = 'device_command_inbox' as const;

/** Fail-closed: key ausente o false = off. */
export function isDeviceCommandInboxEnabled(
  flags: GlobalFeatureFlagsMap | null | undefined,
): boolean {
  return flags?.device_command_inbox === true;
}

export async function resolveDeviceCommandInboxActive(): Promise<boolean> {
  const cached = getCachedGlobalFeatureFlagsForSync();
  if (cached !== undefined) return isDeviceCommandInboxEnabled(cached);
  const flags = await fetchGlobalFeatureFlags();
  return isDeviceCommandInboxEnabled(flags);
}
